import styled from 'styled-components';
import { forceBreakTextCss } from '../../../styles';
export const Container = styled.div `
    width: min(80vw, 375px);
    h4 {
        font-family: Poppins;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        margin: 0;
        color: #ffffff;
    }
`;
export const LinkButtonContainer = styled.div `
    display: flex;
    margin-top: 24px;
`;
export const ContentContainer = styled.div `
    padding: 32px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h4 {
        color: ${(props) => props.$color};
    }
    ${forceBreakTextCss};
`;
export const CheckIconContainer = styled.div `
    height: 56px;
    width: 56px;
    background-color: ${(props) => props.$bgColor};
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    text-align: center;
    display: flex;
    margin-bottom: 24px;
`;
